<script setup lang="ts">
  import { Text } from "../Text";
  import { Connection } from "../Connection";
  import { IconServerConnection, IconServerEventsConnection, IconRfidReader, IconBarcodeScanner, IconBattery } from "../Icons";
  import { useStatusBar } from "./useStatusBar";

  const { rfidPowerVisible = false } = defineProps<{
    /** Отображать мощность RFID-считывателя */
    rfidPowerVisible?: boolean;
  }>();

  const { statusBar } = useStatusBar();
</script>

<template>
  <div class="statusbar">
    <Connection :status="statusBar.rfidStatus.currentStatus" class="statusbar__rfid">
      <Text v-if="rfidPowerVisible && statusBar.rfidPower" class="statusbar__power" font="body-regular-12" color="secondary">
        {{ statusBar.rfidPower }}
      </Text>
      <IconRfidReader class="statusbar__icon" />
    </Connection>
    <Connection :status="statusBar.barcodeStatus.currentStatus">
      <IconBarcodeScanner class="statusbar__icon" />
    </Connection>
    <Connection :status="statusBar.eventsStatus.currentStatus" class="statusbar__right">
      <IconServerEventsConnection class="statusbar__icon" />
    </Connection>
    <Connection :status="statusBar.serverStatus.currentStatus">
      <IconServerConnection class="statusbar__icon" />
    </Connection>
    <div class="statusbar__battery">
      <IconBattery class="statusbar__battery-icon" />
      <Text class="statusbar__battery-text" font="body-regular-10" color="white">
        {{ statusBar.batteryLevel }}
      </Text>
    </div>
  </div>
</template>

<style scoped>
  .statusbar {
    display: flex;
    gap: 6px;
    align-items: center;
    padding: 16px 20px 8px;
  }

  .statusbar__rfid {
    gap: 0;
  }

  .statusbar__power {
    display: block;
    text-align: right;
    width: 15px;
    line-height: 20px;
  }

  .statusbar__rfid :deep(.connection__dot) {
    margin-left: 4px;
  }

  .statusbar__icon {
    width: 20px;
    height: 20px;
    stroke: var(--sf-base-icon-secondary);
  }

  .statusbar__right {
    margin-left: auto;
  }

  .statusbar__battery {
    display: flex;
    position: relative;
    width: fit-content;
    height: fit-content;
  }

  .statusbar__battery-icon {
    fill: var(--sf-base-icon-secondary);
  }

  .statusbar__battery-text {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    padding-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--sf-base-text-white);
  }
</style>
